import React, { CSSProperties, FunctionComponent } from 'react';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { CarouselNavButtons, HeroBanner } from '../..';
import { IHeroBannerWidget } from '../../../../models/campaign-pages/widgets/hero-banner/hero-banner.model';
import styles from './hero-banner-carousel-component.module.scss';
export type HeroBannerCarouselProps = { widget: IHeroBannerWidget };

export const HeroBannerCarousel: FunctionComponent<HeroBannerCarouselProps> = (props: HeroBannerCarouselProps) => {
  function getBanners() {
    return props.widget.banners.map((b, index) => {
      return (
        <SwiperSlide
          key={index}
          className={`${styles['hero-banner-carousel-container']} ${styles['banner-type-' + b.mobileContentStyle]}`}
          style={
            {
              '--content-container-border-height': b.mobileOverlayColour === 'white' ? '0px' : '8px',
            } as CSSProperties
          }>
          <HeroBanner banner={b} numOfBannersInCarousel={props.widget.banners.length} />
        </SwiperSlide>
      );
    });
  }

  return (
    <div className={styles['carousel-container']}>
      <Swiper slidesPerView={1} autoHeight={true}>
        {getBanners()}
        {props.widget.banners.length > 1 && <CarouselNavButtons />}
      </Swiper>
    </div>
  );
};

export default HeroBannerCarousel;
